import React from 'react';
import { connect } from 'react-redux';
import Draggable from 'react-draggable';
import storeManager from '../../../store/StoreManager';
import configuration from '../../../constants/Configuration';
import modeType from '../../../constants/ModeConstants';
import appParameters from '../../utils/AppParameters';
import properties from '../../../constants/Properties';
import hoverManager from '../../utils/HoverManager';
import { setMarkerPosition } from '../../../actions/AudioEditorActions';
import { VolumeSlider } from '../../menus/VolumeSlider';
import platformDetection from '../../utils/PlatformDetection';
import exportPlayerController from '../../utils/ExportPlayerController';
import previewCommands from '../../utils/PreviewCommands';
import fullScreenManager from '../../utils/FullScreenManager';
import mouseUtils from '../../utils/MouseUtils';
import locales from "../../../locales/LocalesManager";

const Button = React.createClass({
    getInitialState () {
        return {
            isOver: false
        };
    },
    onButtonMouseIn() {
        var isAudioExport = (appParameters.context == modeType.EXPORT_AUDIO_PLAYER);

        switch (this.props.index) {
            case 0: { // Start
                if (isAudioExport)
                    hoverManager.show(this.refs.holder, 'startAudio');
                else
                    hoverManager.show(this.refs.holder, 'firstSlide');
                break;
            }
            case 1: { // Back with 10s
                hoverManager.show(this.refs.holder, 'backAudio');
                break;
            }
            case 2: { // Previous slide
                hoverManager.show(this.refs.holder, 'previousSlide');
                break;
            }
            case 3: { // Play
                if (exportPlayerController.isPlaying())
                    hoverManager.show(this.refs.holder, 'previewModePauseCartoon');
                else
                    hoverManager.show(this.refs.holder, 'previewModePlayCartoon');

                break;
            }
            case 4: { // Next slide
                hoverManager.show(this.refs.holder, 'nextSlide');
                break;
            }
            case 5: { // Next with 10s
                hoverManager.show(this.refs.holder, 'nextAudio');
                break;
            }
            case 6: { // End
                if (isAudioExport)
                    hoverManager.show(this.refs.holder, 'endAudio');
                else
                    hoverManager.show(this.refs.holder, 'lastSlide');
                break;
            }
            case 7: { // Volume
                hoverManager.show(this.refs.holder, 'changeVolume');
                break;
            }
            case 8: {
                if (this.props.src.indexOf('normalScreen') != -1)
                    hoverManager.show(this.refs.holder, 'normalScreen');
                else
                    hoverManager.show(this.refs.holder, 'fullScreen');
                break;
            }
        }

        this.setState({
            isOver: true
        });
    },
    getButtonAriaLabel() {
        var text = '';
        var isAudioExport = (appParameters.context == modeType.EXPORT_AUDIO_PLAYER);

        switch (this.props.index) {
            case 0: { // Start
                if (isAudioExport)
                    text = locales.getCaption('startAudio', 'hover');
                else
                    text = locales.getCaption('firstSlide', 'hover');
                break;
            }
            case 1: { // Back with 10s
                text = locales.getCaption('backAudio', 'hover');
                break;
            }
            case 2: { // Previous slide
                text = locales.getCaption('previousSlide', 'hover');
                break;
            }
            case 3: { // Play
                if (exportPlayerController.isPlaying())
                    text = locales.getCaption('previewModePauseCartoon', 'hover');
                else
                    text = locales.getCaption('previewModePlayCartoon', 'hover');

                break;
            }
            case 4: { // Next slide
                text = locales.getCaption('nextSlide', 'hover');
                break;
            }
            case 5: { // Next with 10s
                text = locales.getCaption('nextAudio', 'hover');
                break;
            }
            case 6: { // End
                if (isAudioExport)
                    text = locales.getCaption('endAudio', 'hover');
                else
                    text = locales.getCaption('lastSlide', 'hover');
                break;
            }
            case 7: { // Volume
                text = locales.getCaption('changeVolume', 'hover');
                break;
            }
            case 8: {
                if (this.props.src.indexOf('normalScreen') != -1)
                    text = locales.getCaption('normalScreen', 'hover');
                else
                    text = locales.getCaption('fullScreen', 'hover');
                break;
            }
        }

        return text;
    },
    onButtonMouseOut() {
        hoverManager.hide();

        this.setState({
            isOver: false
        });
    },
    rejectMouseUpEvent() {
        if (platformDetection.isChromeBook()) {
            var currentTime = new Date().getTime();
            var lastClickTime = mouseUtils.mouseUpTime;

            if (lastClickTime != 0 && (currentTime - lastClickTime) < 100)
                return true;
            else
                return false;
        } else
            return false;
    },
    onClick() {
        hoverManager.hide();

        if (platformDetection.isIOS() || platformDetection.isAndroid())
            return;

        if (this.rejectMouseUpEvent())
            return;

        mouseUtils.mouseUpTime = new Date().getTime();

        if (this.props.handleAction)
            this.props.handleAction(this.props.index);
    },
    onTouchEnd() {
        hoverManager.hide();

        if (this.rejectMouseUpEvent())
            return;

        mouseUtils.mouseUpTime = new Date().getTime();

        if (this.props.handleAction)
            this.props.handleAction(this.props.index);
    },
    getSoundIcon() {
        const state = storeManager.getState();
        var soundVolume = state.audioEditor.volume;

        if (soundVolume == undefined)
            soundVolume = 0.5;

        var volumeIcon = 'fa fa-volume-down fa-2x';

        if (soundVolume == 0)
            volumeIcon = 'fa fa-volume-off fa-2x';
        else if (soundVolume <= 0.5)
            volumeIcon = 'fa fa-volume-down fa-2x';
        else if (soundVolume > 0.5)
            volumeIcon = 'fa fa-volume-up fa-2x';

        return volumeIcon;
    },
    render() {
        var leftPosition;
        const middle = this.props.barWidth / 2;
        const isMobileValue = (window.outerWidth < 450 && window.outerWidth > 0) || (window.outerHeight < 450 && window.outerHeight > 0);
        var gap = isMobileValue ? 5 : properties.PREVIEW_BUTTONS_GAP;
        const buttonSize = isMobileValue ? 28 : properties.PREVIEW_HEIGHT;
        var isAudioExport = (appParameters.context == modeType.EXPORT_AUDIO_PLAYER);

        switch (this.props.index) {
            case 0: {
                leftPosition = middle - buttonSize/ 2 - gap * 2 - buttonSize * 2;
                break;
            }
            case 1: {
                leftPosition = middle - buttonSize / 2 - gap * 1.5 - buttonSize;
                break;
            }
            case 2: {
                leftPosition = middle - buttonSize / 2 - gap * 1.5 - buttonSize;
                break;
            }
            case 3: {
                leftPosition = middle - buttonSize / 2;
                break;
            }
            case 4: {
                leftPosition = middle + buttonSize / 2 + gap * 1.5;
                break;
            }
            case 5: {
                leftPosition = middle + buttonSize / 2 + gap * 1.5;
                break;
            }
            case 6: {
                leftPosition = middle + buttonSize / 2 + gap * 2 + buttonSize;
                break;
            }
            case 7: { // volume
                if (isAudioExport)
                    leftPosition = this.props.barWidth - buttonSize - 35;
                else {
                    if (isMobileValue)
                        leftPosition = this.props.barWidth - 2 * buttonSize - 15;
                    else
                        leftPosition = this.props.barWidth - 2 * buttonSize - 45;
                }
                break;
            }
            case 8: { // fullscreen
                if (isAudioExport)
                    leftPosition = 35;
                else {
                    if (isMobileValue)
                        leftPosition = this.props.barWidth - buttonSize - 5;
                    else
                        leftPosition = this.props.barWidth - buttonSize - 28;
                }
                break;
            }
        }

        const buttonStyle = {
            width: buttonSize,
            height: properties.PREVIEW_HEIGHT,
            position: 'absolute',
            left: leftPosition,
            top: 0,
            cursor: 'pointer',
            background: 'none',
            borderStyle: 'none'
        };

        var iconSrc = this.props.src;
        var opacity = 1;
        var iconStyle;
        var iconElement;
        var iconSize = this.props.index == 3 ? properties.PREVIEW_BUTTON_SIZE * 2 : properties.PREVIEW_BUTTON_SIZE * 1.5;

        if (!isAudioExport)
            iconSize = properties.PREVIEW_BUTTON_SIZE;

        if (this.state.isOver == true && !platformDetection.isIOS())
            opacity = 0.4;

        if (this.props.index == 7) { // volume button
            iconStyle = {
                position: 'absolute',
                top: 10,
                left: 10,
                color: '#4b4c4c',
                opacity: opacity
            };

            iconElement = <i style={iconStyle} className={this.getSoundIcon()}></i>;
        } else {
            if (this.props.index == 8) {
                if (this.props.src.indexOf('normalScreen') != -1)
                    iconSize = properties.PREVIEW_BUTTON_SIZE * 2.2;
                else
                    iconSize = properties.PREVIEW_BUTTON_SIZE * 1.2;
            }

            iconStyle = {
                position: 'absolute',
                top: properties.PREVIEW_HEIGHT / 2 - iconSize / 2,
                left: buttonSize / 2 - iconSize / 2,
                width: iconSize,
                height: iconSize,
                opacity: opacity
            };

            iconElement = <img alt='' aria-hidden='true' style={iconStyle} src={iconSrc}/>;
        }

        var elementId = 'audioElementVolume_' + this.props.index;

        if (this.props.index == 3)
            elementId = 'playButtonElement';

        return (
            <button aria-label={this.getButtonAriaLabel()} ref='holder' id={elementId} style={buttonStyle} onTouchEnd={this.onTouchEnd} onClick={this.onClick} onMouseOver={this.onButtonMouseIn} onMouseOut={this.onButtonMouseOut}>
                {iconElement}
            </button>
        );
    }
});

const ExportPlayerContent = React.createClass({
    getInitialState() {
        return {
            isPlaying: false,
            isPlayheadOver: false,
            openVolumeSlider: false,
            isMediaLoaded: false
        };
    },
    componentDidMount() {
        this.updateTrackWidth();
        fullScreenManager.refreshExportPlayer = this.refreshWhenToogleFullScreen;
        fullScreenManager.refreshFunction = this.refreshView;
        exportPlayerController.keyboardShortcutAction = this.handleKeyboardAction;

        document.addEventListener('mousedown', this.onCloseVolumeSlider);
        document.addEventListener('touchstart', this.onCloseVolumeSlider);

        if (platformDetection.isIOS())
            window.addEventListener('orientationchange', this.onResize);
        else
            window.addEventListener('resize', this.onResize);

        if (fullScreenManager.isIOSMode() && fullScreenManager.isFullScreenMode())
            fullScreenManager.addFullScreenEventsForIOS();
    },
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.onCloseVolumeSlider);
        document.removeEventListener('touchstart', this.onCloseVolumeSlider);
    },
    onResize() {
        this.updateTrackWidth();
        this.refreshView();
    },
    refreshView() {
        this.forceUpdate();
    },
    updateTrackWidth() {
        var properties = this.getPositionProperties();
        exportPlayerController.trackWidth = properties.w - 2 * this.getTextWidth();
    },
    onCloseVolumeSlider (e) {
        const target = e.target;

        var volume = 'audioElementVolume_7';

        if (target == undefined || (target && target.id == volume) || (target.parentElement && target.parentElement.id == volume))
            return;

        if (target.id && target.id.indexOf('volumeIcon') != -1) {
            this.setState({
                openVolumeSlider: false
            });

            return;
        }

        if (target.id.indexOf('volumeSlider') != -1 || (target.parentElement && target.parentElement.id.indexOf('volumeSlider') != -1) || (target.parentElement && target.parentElement.parentElement && target.parentElement.parentElement.id.indexOf('volumeSlider') != -1))
            return;

        this.setState({
            openVolumeSlider: false
        });
    },
    updateButtons() {
        this.setState({
            isPlaying: false
        });
    },
    handleKeyboardAction(value) {
        var index = 3;

        if (appParameters.context == modeType.EXPORT_PLAYER) {
            if (value == 'left')
                index = 2;
            else if (value == 'right')
                index = 4;

        } else {
            if (value == 'left')
                index = 1;
            else if (value == 'right')
                index = 5;
        }

        this.handleAction(index);
    },
    handleAction(index) {
        if (index == 3) { // Play
            this.doPlay();
            return;
        }

        if (index == 7) { // Volume
            this.setState({
                openVolumeSlider: true
            });

            return;
        }

        var newPosition = 0;
        var totalTime = exportPlayerController.getVideoTotalTime();

        switch (index) {
            case 0: { // Start
                newPosition = 0;
                break;
            }
            case 1: { // back with 10s
                newPosition = this.props.markerPosition - 10;
                break;
            }
            case 2: { // previous slide
                newPosition = exportPlayerController.getPreviousSlideTime();
                break;
            }
            case 4: { // next slide
                newPosition = exportPlayerController.getNextSlideTime();
                break;
            }
            case 5: { // next with 10s
                newPosition = this.props.markerPosition + 10;
                break;
            }
            case 6: { // end
                if (appParameters.context == modeType.EXPORT_PLAYER)
                    newPosition = exportPlayerController.getNextSlideTime(true);
                else
                    newPosition = totalTime;
                break;
            }
            case 8: { // fullScreen
                fullScreenManager.goFullScreenMode();
                this.refreshWhenToogleFullScreen();
                return;
                break;
            }
        }

        if (newPosition < 0)
            newPosition = 0;

        if (newPosition > totalTime)
            newPosition = totalTime;

        this.setNewPosition(newPosition);
    },
    refreshWhenToogleFullScreen() {
        setTimeout(function() {
            this.updateTrackWidth();
            this.forceUpdate();
        }.bind(this), 300);
    },
    setNewPosition(position) {
        exportPlayerController.setVideoPosition(position);
        this.props.dispatch(setMarkerPosition(position));
    },
    doPlay() {
        exportPlayerController.play(!this.state.isPlaying);
        this.togglePlayState();
    },
    togglePlayState() {
        if (!this.state.isPlaying) {
            this.setState({
                isPlaying: true
            });
        } else {
            this.setState({
                isPlaying: false
            });
        }
    },
    onTrackClick(e) {
        if (e.target && e.target.id == 'playHead')
            return;

        var localX = e.nativeEvent.offsetX;

        if (e.nativeEvent.touches && e.nativeEvent.touches.length > 0)
            localX = e.nativeEvent.touches[0].clientX - this.getTextWidth();

        var markerPosition = exportPlayerController.getMarkerTime(localX);
        this.setNewPosition(markerPosition);
    },
    onMouseDown() {
        var leftString = this.refs.thumb.style.left;
        var left = Number(leftString.substring(0, leftString.length - 2)) + properties.PLAYHEAD_SIZE / 2;

        this.setState({
            startPosition: left,
            isThumbActive: true
        });
    },
    onMouseMove(e, coreEvent) {
        this.checkPosition(coreEvent.lastX);
    },
    onMouseUp(e, coreEvent) {
        this.checkPosition(coreEvent.lastX);

        this.setState({
            isThumbActive: false
        });
    },
    checkPosition(deltaX) {
        var newPosition = (this.state.startPosition +  deltaX);

        if (newPosition < 0)
            newPosition = 0;
        else if (newPosition > exportPlayerController.trackWidth)
            newPosition = exportPlayerController.trackWidth;

        var markerPos = exportPlayerController.getMarkerTime(newPosition);
        this.setNewPosition(markerPos);
    },
    onPlayheadMouseIn() {
        this.setState({
            isPlayheadOver: true
        });
    },
    onPlayheadMouseOut() {
        this.setState({
            isPlayheadOver: false
        });
    },
    getVideoSrc() {
        var exportId = appParameters.exportId;
        var hostName = 'https://stage.creaza.com';

        if (configuration.LOAD_LOCAL == true) {
            if (appParameters.context == 'exportPlayer')
                exportId = 75410387; // Cartoonist
            else
                exportId = 75412400; // AE
        }

        if (configuration.IS_PROD() && !configuration.LOAD_LOCAL)
            hostName = 'https://www.creaza.com';

        return hostName + '/file/ci/' + exportId + '/aaa' + '?cacheBreaker=' + Math.random();
    },
    endMedia() {
        this.setState({
            isPlaying: false
        });

        exportPlayerController.play(false);
    },
    onVideoLoaded() {
        this.setState({
            isMediaLoaded: true
        });

        if (this.state.isMediaLoaded)
            return;

        if (platformDetection.isIOS()) {
            var video = document.getElementById('exportedVideo');

            if (!video)
                return;

            try {
                video.load();

                if (appParameters.playerCurrentTime > 0) {
                    setTimeout(function (videoElement) {
                        videoElement.currentTime = appParameters.playerCurrentTime;
                    }.bind(this), 200, video);
                }
            } catch (e) {
                // error
            }
        }
    },
    getPositionProperties() {
        var height = this.props.windowHeight;
        var scale = (appParameters.context == modeType.EXPORT_AUDIO_PLAYER || fullScreenManager.isFullScreenMode()) ? height / configuration.CANVAS_HEIGHT : (height - properties.PLAYER_BAR_HEIGHT_FOR_CARTOONIST) / configuration.CANVAS_HEIGHT;
        var width = configuration.CANVAS_WIDTH * scale;
        var topY = 0;
        var topX = (this.props.windowWidth - width) / 2;

        if (width > this.props.windowWidth) {
            width = this.props.windowWidth;
            scale = width / configuration.CANVAS_WIDTH;
            height = configuration.CANVAS_HEIGHT * scale;
            topX = 0;
            topY = (this.props.windowHeight - height) / 2;
        }

        return {w: width, h: height, x: topX, y: topY};
    },
    getTextWidth() {
        var isAudio = appParameters.context == modeType.EXPORT_AUDIO_PLAYER;
        var textWidth = isAudio ? 130 : 70;

        return textWidth;
    },
    render() {
        var position = this.getPositionProperties();
        var width = position.w;
        var height = position.h;
        var isAudio = appParameters.context == modeType.EXPORT_AUDIO_PLAYER;

        var menuStyle = {
            position: 'absolute',
            width: position.w,
            height: position.h,
            top: position.y,
            left: position.x,
            cursor: 'default',
            userSelect: 'none',
            userDrag: 'none'
        };

        var controlBarOpacity = 1;

        if (appParameters.context != modeType.EXPORT_AUDIO_PLAYER && fullScreenManager.isFullScreenMode() == true) { // Cartoonist in fullScreen mode
            if (fullScreenManager.isControlBarVisible() == false)
                controlBarOpacity = 0;
            else
                controlBarOpacity = 0.6;
        }

        var barStyle = {
            position: 'absolute',
            bottom: 0,
            left: 0,
            width: width,
            height: isAudio ? properties.PLAYER_BAR_HEIGHT : properties.PLAYER_BAR_HEIGHT_FOR_CARTOONIST,
            backgroundImage: 'linear-gradient(rgb(255, 176, 45), rgb(255, 255, 255), rgb(255, 176, 45))',
            opacity: controlBarOpacity
        };

        var buttonsHolderStyle = {
            position: 'absolute',
            top: properties.PLAYER_BAR_HEIGHT / 2,
            left: 0,
            width: width,
            height: isAudio ? properties.PLAYER_BAR_HEIGHT / 2 : properties.PREVIEW_HEIGHT
        };

        var controlBarStyle = {
            position: 'absolute',
            top: 0,
            left: 0,
            width: width,
            height: isAudio ? properties.PLAYER_BAR_HEIGHT / 2 : properties.PLAYHEAD_SIZE_FOR_CARTOONIST
        };

        var textHeight = isAudio ? 20 : 25;
        var textWidth = this.getTextWidth();

        var leftSpanStyle = {
            color: 'black',
            fontSize: 18,
            cursor: 'default',
            position: 'absolute',
            textAlign: 'center',
            width: textWidth,
            height: textHeight,
            left: 0,
            top: controlBarStyle.height / 2 - textHeight / 2
        };

        var rightSpanStyle = {
            color: 'black',
            fontSize: 18,
            cursor: 'default',
            position: 'absolute',
            textAlign: 'center',
            width: textWidth,
            height: textHeight,
            left: width - textWidth,
            top: controlBarStyle.height / 2 - textHeight / 2
        };

        const playhedSize = isAudio ? properties.PLAYHEAD_SIZE : properties.PLAYHEAD_SIZE_FOR_CARTOONIST;
        const trackHeight = isAudio ? 10 : playhedSize;
        var trackStyle = {
            position: 'absolute',
            width: width - 2 * textWidth,
            height: playhedSize,
            left: textWidth,
            top: controlBarStyle.height / 2 - playhedSize / 2
        };

        var currentPosition = exportPlayerController.getMarkerPosition();

        if (!currentPosition)
            currentPosition = 0;

        var trackNormalStyle = {
            position: 'absolute',
            background: '#898b8b',
            width: trackStyle.width,
            height: trackHeight,
            left: 0,
            top: trackStyle.height / 2 - trackHeight / 2
        };

        var trackShadowStyle = {
            position: 'absolute',
            background: '#00B3EC',
            width: currentPosition,
            height: trackHeight,
            left: 0,
            top: trackStyle.height / 2 - trackHeight / 2
        };

        var playheadStyle = {
            position: 'absolute',
            background: isAudio ? 'white' : '#4bade9',
            width: playhedSize,
            height: playhedSize,
            left: currentPosition - playhedSize / 2,
            top: trackStyle.height / 2 - playhedSize / 2,
            borderRadius: 50,
            boxShadow: 'inset 0 0 6px rgba(0, 0, 0, 0.3)',
            cursor: 'pointer'
        };

        if (this.state.isThumbActive || this.state.isPlayheadOver) {
            if (isAudio)
                playheadStyle.background = '#ffb02d';
            else
                playheadStyle.background = '#4bbddd';
        }

        var playSrc = appParameters.RESOURCES_LOCATION() + 'assets/player/play.png';

        if (this.state.isPlaying)
            playSrc = appParameters.RESOURCES_LOCATION() + 'assets/player/pause.png';

        const videoHolderStyle = {
            position: 'absolute',
            left: 0,
            width: menuStyle.width
        };

        var preloader;

        if (!this.state || !this.state.isMediaLoaded) {
            const wrapperStyle = {
                position: 'absolute',
                background: '#333333',
                opacity: 0.5,
                top: 0,
                left: 0,
                width: menuStyle.width,
                height: menuStyle.height
            };

            const size = 48;

            const loaderStyle = {
                position: 'absolute',
                top: wrapperStyle.height / 2 - size / 2,
                left: wrapperStyle.width / 2 - size / 2,
                color: 'white'
            };

            preloader =
                <div style={wrapperStyle}>
                    <i style={loaderStyle} className="fa fa-spinner fa-pulse fa-3x" />
                </div>;
        }

        var fullScreenSrc;

        if (platformDetection.isIOS()) {
            if (previewCommands.isIOSFullScreen)
                fullScreenSrc = appParameters.RESOURCES_LOCATION() + 'assets/player/normalScreen.png';
            else
                fullScreenSrc = appParameters.RESOURCES_LOCATION() + 'assets/player/fullScreen.png';
        } else {
            if (fullScreenManager.isFullScreenMode())
                fullScreenSrc = appParameters.RESOURCES_LOCATION() + 'assets/player/normalScreen.png';
            else
                fullScreenSrc = appParameters.RESOURCES_LOCATION() + 'assets/player/fullScreen.png';
        }

        exportPlayerController.updateVolume();

        const isMobileValue = (window.outerWidth < 450 && window.outerWidth > 0) || (window.outerHeight < 450 && window.outerHeight > 0);
        var audioBackground;
        var backBtn;
        var nextBtn;
        var volumeSliderLeft = width - 71;
        var slidesElement;

        if (appParameters.context == modeType.EXPORT_AUDIO_PLAYER) {
            const backgroundStyle = {
                position: 'absolute',
                top: 0,
                left: 0,
                width: menuStyle.width,
                height: height - properties.PLAYER_BAR_HEIGHT,
                backgroundImage: 'linear-gradient(rgb(255, 176, 45), rgb(255, 255, 255), rgb(255, 176, 45))'
            };

            // image size 367x258
            const backgroundIconStyle = {
                position: 'absolute',
                top: backgroundStyle.height / 2 - 258 / 2,
                left: width / 2 - 367 / 2,
                borderRadius: 100
            };

            var src = appParameters.RESOURCES_LOCATION() + 'assets/audioPlayerBackground.png';

            audioBackground = <div style={backgroundStyle}>
                <img alt='' aria-hidden='true' style={backgroundIconStyle} src={src}/>
            </div>;

            backBtn = <Button dispatch={this.props.dispatch} index={1} src={appParameters.RESOURCES_LOCATION() + 'assets/player/goBack.svg'} barWidth={width} handleAction={this.handleAction}/>;
            nextBtn = <Button dispatch={this.props.dispatch} index={5} src={appParameters.RESOURCES_LOCATION() + 'assets/player/goNext.svg'} barWidth={width} handleAction={this.handleAction}/>;
        } else {
            backBtn = <Button dispatch={this.props.dispatch} index={2} src={appParameters.RESOURCES_LOCATION() + 'assets/player/back.png'} barWidth={width} handleAction={this.handleAction}/>;
            nextBtn = <Button dispatch={this.props.dispatch} index={4} src={appParameters.RESOURCES_LOCATION() + 'assets/player/next.png'} barWidth={width} handleAction={this.handleAction}/>;

            barStyle.backgroundImage = undefined;
            barStyle.background = '#edeeef';

            controlBarStyle.background = '#ffffff';
            trackStyle.height = controlBarStyle.height;
            trackStyle.top = 0;

            trackNormalStyle.background = '#cfd0d1';
            trackShadowStyle.background = '#4bade9';

            leftSpanStyle.fontSize = 17;
            leftSpanStyle.fontWeight = 'bold';
            leftSpanStyle.top = 1;

            rightSpanStyle.fontSize = 17;
            rightSpanStyle.fontWeight = 'bold';
            rightSpanStyle.top = 1;

            if (isMobileValue)
                volumeSliderLeft = volumeSliderLeft - 5;
            else
                volumeSliderLeft = volumeSliderLeft - 60;

            var slidesElementStyle = {
                color: 'black',
                fontSize: 17,
                fontWeight: 'bold',
                cursor: 'default',
                position: 'absolute',
                textAlign: 'center',
                width: textWidth,
                height: textHeight,
                left: 0,
                top: 13
            };

            slidesElement = <span style={slidesElementStyle}>{exportPlayerController.getSlidesText()}</span>;

            buttonsHolderStyle.top = trackHeight;
        }

        var startBtn = <Button dispatch={this.props.dispatch} index={0} src={appParameters.RESOURCES_LOCATION() + 'assets/player/start.png'} barWidth={width} handleAction={this.handleAction}/>;
        var endBtn = <Button dispatch={this.props.dispatch} index={6} src={appParameters.RESOURCES_LOCATION() + 'assets/player/end.png'} barWidth={width} handleAction={this.handleAction}/>;

        if (appParameters.isExternVideo) {
            startBtn = undefined;
            endBtn = undefined;
            backBtn = undefined;
            nextBtn = undefined;
            slidesElement = undefined;
        }

        var exportAudioFullScreen;
        var exportCartoonistFullScreen;

        if (appParameters.context == modeType.EXPORT_AUDIO_PLAYER)
            exportAudioFullScreen = <Button dispatch={this.props.dispatch} index={8} barWidth={width} src={fullScreenSrc} barWidth={width} handleAction={this.handleAction}/>;
        else
            exportCartoonistFullScreen = <Button dispatch={this.props.dispatch} index={8} barWidth={width} src={fullScreenSrc} barWidth={width} handleAction={this.handleAction}/>;

        return (
            <div style={menuStyle}>
                <div style={videoHolderStyle} id="svgContainer">
                    <video id="exportedVideo" width="100%" onEnded={this.endMedia} onDurationChange={this.onVideoLoaded}>
                        <source src={this.getVideoSrc()}/>
                    </video>
                </div>

                {audioBackground}

                <div style={barStyle} id="previewMenu">
                    <div style={controlBarStyle}>
                        <span style={leftSpanStyle}>{exportPlayerController.getCurrentTime(isAudio)}</span>
                        <span style={rightSpanStyle}>{exportPlayerController.getTotalTime(isAudio)}</span>
                        <div style={trackStyle} onTouchStart={this.onTrackClick} onMouseDown={this.onTrackClick}>
                            <div style={trackNormalStyle}/>
                            <div style={trackShadowStyle}/>
                            <Draggable axis='none' position={{x: 0, y: 0}} onStart={this.onMouseDown} onDrag={this.onMouseMove} onStop={this.onMouseUp}>
                                <div style={playheadStyle} id='playHead' ref='thumb' onMouseOver={this.onPlayheadMouseIn} onMouseOut={this.onPlayheadMouseOut}/>
                            </Draggable>
                        </div>
                    </div>

                    <div style={buttonsHolderStyle}>
                        {exportAudioFullScreen}

                        {startBtn}
                        {backBtn}

                        <Button dispatch={this.props.dispatch} index={3} src={playSrc} barWidth={width} handleAction={this.handleAction}/>

                        {nextBtn}
                        {endBtn}

                        <Button dispatch={this.props.dispatch} index={7} barWidth={width} handleAction={this.handleAction}/>

                        {exportCartoonistFullScreen}

                        <VolumeSlider dispatch={this.props.dispatch} visible={this.state.openVolumeSlider} type={'audioToolPlayer'} positionLeft={volumeSliderLeft}/>

                        {slidesElement}
                    </div>
                </div>

                {preloader}
            </div>
        );
    }
});

function mapStateToProps() {
    const state = storeManager.getState();
    var markerPosition = state.audioEditor.markerPosition;
    var volume = state.audioEditor.volume;

    if (!markerPosition)
        markerPosition = 0;

    if (volume == undefined)
        volume = 0.5;

    return {
        markerPosition,
        volume
    };
}

export const ExportPlayer = connect(mapStateToProps)(ExportPlayerContent);



/** WEBPACK FOOTER **
 ** ./src/components/audioTool/menus/ExportPlayer.js
 **/